import YearSelectorComponent from "../yearSelector/YearSelectorComponent";
import RegionSelectorComponent from "../regionSelector/RegionSelectorComponent";
import React, {useState} from "react";
import styled from "styled-components";
import classnames from "classnames";


const TabHeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: baseline;

    @media (min-width: 481){
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 0px;
        align-items: center;
        min-height: 140px;
    }

    @media (max-width: 480px) {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        margin-bottom: 0px !important;
        align-items: center;
    }

    .darkColor {
        color: #1A1A1A;
    }
`;

interface TabHeaderProps {
    customStyle?: object
    darkMode?: boolean
}

const TabHeader: React.FC<TabHeaderProps> = ({ customStyle= {}, darkMode=false }) => {
    const [showRegion, setShowRegion] = useState(true);
    return (
        <>
          <TabHeaderContainer style={{...customStyle}} className={classnames( {'darkColor': darkMode})} >
              <YearSelectorComponent customStyle={{marginBottom: 0, maxWidth: '60%', maxHeight: 94}} darkMode={darkMode} setShowRegion={setShowRegion}/>
              { showRegion && <RegionSelectorComponent customStyle={{ justifyContent: 'flex-end' }} /> }
          </TabHeaderContainer>
        </>
    )
};

export default TabHeader;
